<template>
  <el-header v-if="$store.state.user" class="nav-container">
    <el-menu
      mode="horizontal"
      background-color="#0c0526"
      text-color="#fff"
      active-text-color="#fff"
      router
    >
      <el-menu-item class="logo">
        <div id="bars" class="mobile-menu-toggle" @click="toggle()">
          <div class="bar"></div>
          <div class="bar"></div>
          <div class="bar"></div>
        </div>
      </el-menu-item>
      <el-menu-item @click.native="openDashboard()">
        <img id="logo" src="@/assets/images/logo.svg" />
      </el-menu-item>
      <el-tooltip
        class="item float-right log-out"
        effect="dark"
        content="Log Out"
        placement="bottom"
      >
        <el-menu-item class="float-right" @click.native="logout('artist')">
          <i class="fas fa-sign-out-alt"></i>
        </el-menu-item>
      </el-tooltip>
      <el-menu-item class="float-right username-nav">
        <p>{{ user.first_name }} {{ user.surname }}</p>
      </el-menu-item>
      <li class="nav-search">
        <div @keydown.stop>
          <el-autocomplete
            v-model="search"
            :fetch-suggestions="remoteMethod"
            :trigger-on-focus="false"
            @select="handleSelect"
            :debounce="500"
            prefix-icon="el-icon-search"
            placeholder="Search track"
            :maxlength="100"
          >
            <div slot-scope="props" class="flex-start">
              <span v-if="props.item.artist_name">
                {{ props.item.artist_name }} - {{ props.item.title }}
              </span>
              <span v-else>
                {{ props.item.name }}
              </span>
            </div>
          </el-autocomplete>
        </div>
      </li>
    </el-menu>
  </el-header>
</template>

<script>
import axios from '@/plugins/axios'
import { mapState, mapMutations } from 'vuex'

export default {
  computed: {
    ...mapState('auth', ['user', 'artist']),
    image() {
      if (this.artist && this.artist.file_name !== null) {
        return this.url + 'artists/' + this.artist.file_name
      } else return null
    }
  },

  data() {
    return {
      search: '',
      url: process.env.VUE_APP_STORAGE_URL,
      dev: process.env.VUE_APP_IN_DEVELOPMENT,
      switch: false
    }
  },

  methods: {
    ...mapMutations('artistDashboard', ['setSelectedTrack']),
    ...mapMutations('auth', ['setToggle']),
    toggle() {
      this.switch = !this.switch
      this.setToggle(this.switch)
    },
    remoteMethod(query, callback) {
      let dummy = {
        id: null,
        name: 'No result',
        type: 'dummy'
      }
      query = query.trim()
      if (query !== '') {
        query = query
          .replace(/[/]/g, '&sol;')
          .replace(/&/g, '&amp;')
          .replace(/>/g, '&gt;')
          .replace(/</g, '&lt;')
          .replace(/"/g, '&quot;')
        axios.artist
          .get(`search/${query}`)
          .then(response => {
            let links = response.data.data
            if (links.length > 0) {
              callback(links)
            } else {
              callback(new Array(dummy))
            }
          })
          .catch(() => {
            this.$message({
              message: 'Search error, please try again',
              type: 'error'
            })
          })
      } else {
        callback(new Array(dummy))
      }
    },
    handleSelect(data) {
      if (data.type != 'dummy') {
        this.setSelectedTrack(data)
        this.$router.push(`/artist/my-tracks/track-details`)
      }
      this.search = ''
    },
    openProfile() {
      this.$router.push('/artist/profile')
    },
    errorHandler() {
      return true
    },
    openDashboard() {
      this.$router.push('/artist/home')
    }
  }
}
</script>

<style lang="scss" scoped>
.el-header {
  position: fixed;
  z-index: 110;
  left: 0;
  width: 100%;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.3);
  .el-button.is-circle {
    background: #e6e5e8;
    border: #e6e5e8;
  }
}

.el-icon-s-data,
.el-icon-mic {
  color: #ffffff;
}

.logo {
  #logo {
    padding: 0 1rem 0 2rem;
  }
}

.log-out {
  padding: 0 2.4rem 0 1.4rem !important;
}

.avatar {
  padding: 0;
  &:hover {
    background-color: none;
  }
}

.dropdown-item {
  height: 45px !important;
  border: none !important;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: white !important;
  i {
    color: #666666;
  }
  &:hover {
    background-color: #eeebeb !important;
    i {
      color: #444444;
    }
  }
}

.el-menu--horizontal > .el-submenu .el-submenu__title,
.el-menu--horizontal > .el-menu-item {
  border-bottom: none !important;
  font-size: 16px;
  &:hover {
    border-bottom: none !important;
    background-color: transparent !important;
  }
}

.el-menu {
  height: 90px;
  .el-menu-item,
  .el-submenu {
    line-height: 90px;
    height: 90px;
    border-bottom: none;
    padding: 0 0 0 20px;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    i {
      color: white;
    }
  }
}
</style>
